/**
 * Route for `custom-tracking-domain`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomTrackingDomainPage } from "../features/custom-tracking-domain/CustomTrackingDomainPage";

export const customTrackingDomainRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-tracking-domain",
	component: CustomTrackingDomainPage,
});

export default customTrackingDomainRoute;
